














import Vue from 'vue'
import i18n from 'vue-i18n'
import { Component, Prop } from 'vue-property-decorator'

import { ProxyDelayIntervalType } from '../../../logic/Proxy/ProxyDelayTypes'
import SampleDelayLimit from '../components/SampleDelayLimit.vue'

@Component({
  components: {
    SampleDelayLimit,
  },
  data() {
    return {
      SampleDelayLimit,
    }
  }
})
export default class SampleDelayIntervalType extends Vue {
  @Prop() delay!: ProxyDelayIntervalType

  @Prop() i18n!: i18n

  @Prop() getFormattedTime!: (time: number) => string
}
